import * as React from "react"
const LockCircleSolidIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={40}
        height={40}
        aria-label="Lock Circle Solid Icon"
        {...props}
    >
        <rect width={40} height={40} fill="currentcolor" fillOpacity={0.08} rx={20} />
        <path
            fill="currentcolor"
            d="M27.2 29.91v-10.8H12.8v10.8h14.4Zm0-13.19c.672 0 1.238.23 1.7.691.46.461.69 1.027.69 1.7v10.8c0 .671-.24 1.238-.72 1.699a2.23 2.23 0 0 1-1.67.72H12.8c-.653 0-1.22-.24-1.7-.72-.46-.461-.69-1.028-.69-1.7v-10.8c0-.672.23-1.238.69-1.699a2.372 2.372 0 0 1 1.7-.691h1.21v-2.39c0-1.114.259-2.122.777-3.024a6.054 6.054 0 0 1 2.16-2.19c.922-.537 1.94-.806 3.053-.806 1.114 0 2.122.27 3.024.807a5.766 5.766 0 0 1 2.16 2.189c.538.902.806 1.91.806 3.024v2.39h1.21ZM20 10.73c-.672 0-1.286.163-1.843.49-.538.306-.97.738-1.296 1.295a3.591 3.591 0 0 0-.461 1.815v2.39h7.2v-2.39c0-.672-.163-1.277-.49-1.815a3.238 3.238 0 0 0-1.296-1.296A3.427 3.427 0 0 0 20 10.73Z" />
    </svg>
)
export default LockCircleSolidIcon